import React from 'react';
import { Camera } from 'lucide-react';

// Importing images from your assets folder
import img1 from '../../assets/1.jpeg';
import img2 from '../../assets/2.jpeg';
import img3 from '../../assets/3.jpeg';
import img4 from '../../assets/4.jpeg';
import img5 from '../../assets/5.jpeg';
import img6 from '../../assets/6.jpeg';
import img7 from '../../assets/7.jpeg';
import img8 from '../../assets/8.jpeg';
import img9 from '../../assets/9.jpeg';
import img10 from '../../assets/10.jpeg';
import img11 from '../../assets/11.jpeg';
import img12 from '../../assets/12.jpeg';
import img13 from '../../assets/13.jpeg';

const Gallery = () => {
  // Horizontal/Standard Images (Shown First)
  const standardPhotos = [
    { id: 3, url: img3, title: 'Temple Architecture' },
    { id: 4, url: img4, title: 'Maha Shivaratri Celebrations' },
    { id: 5, url: img5, title: 'Gathering of Devotees' },
    { id: 6, url: img6, title: 'Devotees at Prayer' },
    { id: 7, url: img7, title: 'Devotees at Prayer' },
    { id: 8, url: img8, title: 'Devotees at Prayer' },
    { id: 9, url: img9, title: 'Sacred Entrance' },
    { id: 11, url: img13, title: 'Devotees at Prayer' },
    { id: 12, url: img11, title: 'Devotees at Prayer' },
    
  ];

  // Vertically Tall Images (Shown Last)
  const verticalPhotos = [
    { id: 1, url: img1, title: 'Main Shivalingam' },
    { id: 2, url: img2, title: 'Main Shivalingam' },
    { id: 10, url: img10, title: 'Sacred Entrance' },
  ];

  const allPhotos = [...standardPhotos, ...verticalPhotos];

  return (
    <section id="gallery" className="py-24 bg-orange-50/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header Section */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 text-orange-600 font-bold tracking-widest text-sm uppercase mb-3">
            <Camera size={20} /> Divine Memories
          </div>
          <h2 className="text-4xl font-serif font-bold text-stone-800">Devasthanam Gallery</h2>
          <div className="h-1 w-20 bg-orange-500 mx-auto mt-4 rounded-full"></div>
          <p className="mt-6 text-stone-600 max-w-xl mx-auto">
            Glimpses of the divine atmosphere and ancient heritage of the Sri Bramhasutra Marakatha Shivalinga Devasthanam.
          </p>
        </div>

        {/* Photo Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 items-start">
          {allPhotos.map((photo) => {
            // Check if this is one of the vertical images
            const isVertical = [1, 2, 10].includes(photo.id);

            return (
              <div 
                key={photo.id} 
                className={`group relative overflow-hidden rounded-3xl bg-white shadow-lg border-4 border-white transition-all hover:shadow-orange-200 
                  ${isVertical ? 'h-auto' : 'aspect-[4/3]'}`}
              >
                <img 
                  src={photo.url} 
                  alt={photo.title}
                  className={`w-full transition-transform duration-700 group-hover:scale-105 
                    ${isVertical ? 'h-full object-contain' : 'h-full object-cover'}`}
                />
                
                {/* Overlay on Hover */}
                <div className="absolute inset-0 bg-gradient-to-t from-orange-900/90 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-8">
                  <div>
                    <h3 className="text-white font-serif font-bold text-xl">{photo.title}</h3>
                    <div className="w-10 h-1 bg-orange-500 mt-2 rounded-full"></div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>


      </div>
    </section>
  );
};

export default Gallery;